var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-100"},[(_vm.pageOptions.showNavbar)?_c('navbar'):_vm._e(),_c('mdb-container',{staticClass:"h-100",attrs:{"fluid":""}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }